// extracted by mini-css-extract-plugin
module.exports = {"remarkInfo":"RemarkInfo_remarkInfo__2PWtd","label":"RemarkInfo_label__2G7fD","remarkTextarea":"RemarkInfo_remarkTextarea__Oskjt"};